import { getFirstName } from './dbHelpers';

let cachedVoice = null;

function pickVoice() {
  if (typeof window === 'undefined' || !window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices();
  return (
    voices.find((voice) =>
      voice.name.includes('Female') ||
      voice.name.includes('Google US English') ||
      voice.name.includes('Zira') ||
      voice.name.includes('Samantha')
    ) ||
    voices.find((voice) => voice.lang?.startsWith('en')) ||
    null
  );
}

export function preloadSpeechVoices() {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;
  cachedVoice = pickVoice();
  window.speechSynthesis.getVoices();
}

export function cancelSpeech() {
  if (typeof window !== 'undefined' && window.speechSynthesis) {
    window.speechSynthesis.cancel();
  }
}

export function speakAttendance(fullName, action = 'login') {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;

  const firstName = getFirstName(fullName);
  const hours = new Date().getHours();
  let greeting = 'Good evening';
  if (hours >= 5 && hours < 12) greeting = 'Good morning';
  else if (hours >= 12 && hours < 18) greeting = 'Good afternoon';

  const message =
    action === 'logout'
      ? firstName
        ? `Goodbye, ${firstName}! Time out recorded.`
        : 'Time out recorded. Goodbye!'
      : firstName
        ? `${greeting}, ${firstName}! Time in recorded.`
        : `${greeting}! Time in recorded.`;

  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(message);
  const voice = cachedVoice || pickVoice();
  if (voice) {
    utterance.voice = voice;
    cachedVoice = voice;
  }
  utterance.lang = 'en-US';
  utterance.pitch = 1.1;
  utterance.rate = 0.95;
  window.speechSynthesis.speak(utterance);
}
